const Glide = window.Glide;
import "../../Components/Widgets/ExhibitorCardList/ExhibitorCardList.scss";
import { disableIfGlideFit, setButtonsVisibility } from "../glideControls.js";
let glides = [];
const exhibitorCardList = (() => {
  // get extended exhibitor data via AJAX
  function setUpCarousel() {
    $(".exhibitorCardListWidget .glide__slide").each(function () {
      let $slide = $(this);
      let exhibitorID = $slide.data("exhibitor-id");
      $.ajax({
        url: "/exhibitor-card/" + exhibitorID,
        success: function (resp) {
          if (resp.logoURL != null && resp.logoURL != "")
            $(".block__imageHolder", $slide)
              .removeClass("block__letter")
              .html(
                `<img src="${resp.logoURL}" alt="${resp.exhibitorName} logo" />`
              );

          $(".h3__title", $slide)
            .attr("data-exhibitor-lines", resp.lines)
            .attr("data-exhibitor-categories", resp.categories.join(","));

          let openLine = resp.isPermanent ? "Permanent" : "Temporary";
          if (resp.openText != null && resp.openText != "")
            openLine += " - " + resp.openText;
          $(".h4__openDates", $slide).text(openLine);

          if (resp.email != null && resp.email != "")
            $(".block__contentEmail", $slide)
              .show()
              .find("a")
              .attr("href", "mailto:" + resp.email)
              .text(resp.email);

          if (resp.phone != null && resp.phone != "")
            $(".block__contentPhone", $slide)
              .show()
              .find("a")
              .attr("href", "tel:" + resp.phone)
              .text(resp.phone);

          if (resp.exhibitorBio != null && resp.exhibitorBio != "")
            $(".block__bio", $slide).show().find("p").html(resp.exhibitorBio);

          let locationCount =
            resp.showrooms.length + (resp.firstTemp == null ? 0 : 1);
          if (locationCount > 0) {
            if (locationCount == 1)
              $(".block__location", $slide)
                .show()
                .find(".address")
                .text(
                  resp.firstTemp != null ? resp.firstTemp : resp.showrooms[0]
                );
            else
              $(".block__location", $slide)
                .show()
                .addClass("multiple")
                .find(".address")
                .text("Multiple locations");
          }

          if (resp.isExhibitorFavorite != null) {
            let heartColor = resp.isExhibitorFavorite ? "red" : "white";
            $(".heart-favorite-icon", $slide)
              .show()
              .find("img")
              .attr("attr-favorite-exhibitor", heartColor)
              .attr("src", `/images/heart-${heartColor}.svg`);
          }
        },
        error: function (jqXHR) {
          console.log(
            `Failed to load exhibitor card ${exhibitorID}: ${jqXHR.textContent}`
          );
        },
      });
    });

    const sliders = document.querySelectorAll(
      ".exhibitorCardListWidget .glide"
    );

    // keeps tracks of several widgets' default state
    const options = {
      perView: 4,
      peek: { before: 0, after: 102 },
      bound: true,
      gap: 16,
      rewind: false,
      breakpoints: {
        400: {
          perView: 1,
          peek: { before: 0, after: 89 },
          gap: 16,
        },
        500: {
          perView: 1,
          peek: { before: 0, after: 190 },
          gap: 16,
        },
        700: {
          perView: 2,
          peek: { before: 0, after: 60 },
          gap: 16,
        },
        919: {
          perView: 2,
          peek: { before: 0, after: 126 },
          gap: 16,
        },
        1023: {
          perView: 3,
          peek: { before: 0, after: 80 },
          gap: 16,
        },
        1194: {
          perView: 3,
          gap: 16,
          peek: { before: 0, after: 102 },
        },
        1365: {
          perView: 4,
          gap: 16,
          peek: { before: 0, after: 142 },
        },
      },
    };
    const intialResultsList = {};
    sliders.forEach((slider) => {
      intialResultsList[`${slider.getAttribute("data-identifier")}`] =
        slider.querySelectorAll(".glide__slide");
    });
    sliders.forEach((slider) => {
      let glide = new Glide(slider, options);
      glide.on("move.after", () => {
        let firstButton = glide.selector.querySelector(
          ".button__glide.button__prev"
        );
        let lastButton = glide.selector.querySelector(
          ".button__glide.button__next"
        );
        let numOfSlides =
          glide.selector.querySelectorAll(".glide__slide").length;
        setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
      });
      glides.push(glide.mount());
    });

    for (let i = 0; i < glides.length; i++) {
      disableIfGlideFit(glides[i]);
    }
    if (sliders) {
      window.addEventListener("resize", () => {
        for (let i = 0; i < glides.length; i++) {
          disableIfGlideFit(glides[i]);
        }
      });
    }
  }
  // Function to filter and show/hide cards based on search text
  const filterCards = (e) => {
    e.preventDefault();
    const exhibitorSelection = e.target.querySelector(
      "input[name='exhibitor-selection']"
    ).value;
    const searchText = e.target
      .querySelector("input[name='search-text']")
      .value.trim()
          .toLowerCase();
    let directoryUrl = e.target.querySelector(
        "input[name='directory-page']"
      )?.value;
    let directoryParams = new URLSearchParams();
    if (searchText.length)
        directoryParams.set('searchText', searchText);

    if (exhibitorSelection == "all") {
      window.location.href = directoryUrl + "?" + directoryParams.toString();
    } else if (exhibitorSelection == "marketspecific") {
      const marketID = e.target.querySelector(
        "[name='marketId']"
      ).value;
      directoryParams.set('marketId', marketID);
      window.location.href = directoryUrl + "?" + directoryParams.toString();
    } else if (exhibitorSelection == "industrycategory") {
      const exhibitorCategories = e.target.querySelector(
        "input[type='hidden'][name='exhibitor-categories']"
        ).value;
      directoryParams.set('category', exhibitorCategories);
      window.location.href = directoryUrl + "?" + directoryParams.toString();
    } else if (exhibitorSelection == "selectedexhibitors") {
        const parentContainer = e.target.parentElement.parentElement;
        showHideCards(searchText, parentContainer);
    }
  };

    function showHideCards(searchText, parentContainer) {
        const cardsContainer = parentContainer.querySelector(".glide__slides");
        const glide__track = parentContainer.querySelector(".glide__track");
        const prevErrorBlock = parentContainer.querySelector(".block__error");

        // reset the container from potentially previous search results filtering
        const cards = parentContainer.querySelectorAll(".glide__slide");
        cards.forEach((card) => { card.style.display = "block" });

        const cardHeight = cards[0].getBoundingClientRect().height;
        let noResults = true;

        // perform search on default container results
        cards.forEach((card) => {
            const h3Element = card.querySelector(".h3__title");
            const cardTitle = h3Element.textContent.trim().toLowerCase();

            // Retrieving data from the data attributes
            const exhibitorLines = h3Element
                .getAttribute("data-exhibitor-lines")
                .trim()
                .toLowerCase();
            const exhibitorCategories = h3Element
                .getAttribute("data-exhibitor-categories")
                .trim()
                .toLowerCase();
            let isMatch = false;
            // Check if the card title contains the search text
            if (cardTitle.includes(searchText)) {
                isMatch = true;
            }
            // Check if the card exhibitorLines contains the search text
            else if (exhibitorLines.includes(searchText)) {
                isMatch = true;
            }
            // Check if the card exhibitorCategories contains the search text
            else if (exhibitorCategories.includes(searchText)) {
                isMatch = true;
            }
            // remove the card based on the search result
            if (!isMatch) {
                card.style.display = "none";
            } else {
                noResults = false;
            }
        });

        // update carousels after showing/hiding slides
        glides.forEach((glide) => {
            glide.update();
            disableIfGlideFit(glide);
        });

        // if no results indicate this to user
        if (noResults) {
            if (prevErrorBlock) {
                cardsContainer.appendChild(prevErrorBlock);
                prevErrorBlock.style.display = "block";
                return;
            }
            // disable glide movement
            glide__track.style.pointerEvents = "none";
            const TEXT_ERROR = "No matches for your search";
            const errorTitle = document.createElement("h3");
            const errorContainer = document.createElement("div");
            errorTitle.textContent = TEXT_ERROR;
            errorContainer.setAttribute("class", "block__error");
            errorContainer.style.height = `${cardHeight}px`;
            errorContainer.append(errorTitle);
            cardsContainer.appendChild(errorContainer);
        } else {
            glide__track.style.pointerEvents = "";
            if (prevErrorBlock)
                prevErrorBlock.style.display = "none";
        }
    }

  $(".exibhitor-favorite").on("click", function () {
    var exhibitorid = $(this).attr("data-attr-exhibitor-id");
    var favorite =
      $(".icon-heart-" + exhibitorid).attr("attr-favorite-exhibitor") == "white"
        ? true
        : false;
    $.ajax({
      url: "/favorite/exhibitor",
      type: "POST",
      data: {
        exhibitorID: exhibitorid,
        favoriteExhibitor: favorite,
      },
      success: function (result) {
        if (favorite) {
          $(".icon-heart-" + exhibitorid).attr("src", "/images/heart-red.svg");
          $(".icon-heart-" + exhibitorid).attr(
            "attr-favorite-exhibitor",
            "red"
          );
        } else {
          $(".icon-heart-" + exhibitorid).attr(
            "src",
            "/images/heart-white.svg"
          );
          $(".icon-heart-" + exhibitorid).attr(
            "attr-favorite-exhibitor",
            "white"
          );
        }
      },
    });
  });

  function isMacOS() {
    return (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)
    );
  }

  function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  function isChrome() {
    return /chrome/i.test(navigator.userAgent) && !isSafari();
  }

  function applyCustomStyles() {
    var elements = document.querySelectorAll(
      ".exhibitorCardListWidget .glide__slides .glide__slide .block__imageHolder.block__letter"
    );

    if (elements.length > 0) {
      if (isMacOS() && (isSafari() || isChrome())) {
        elements.forEach(function (element) {
          //element.style.alignItems = 'center';
          //element.style.paddingBottom = '1px';
          element.style.lineHeight = "42px";

          // Force reflow to ensure rendering
          element.offsetHeight; // This forces a reflow
        });
      }
    }
  }

  applyCustomStyles();
  setUpCarousel();
  window.filterCards = filterCards;
  return {setUpCarousel : setUpCarousel}
})();

export {exhibitorCardList};